import React from 'react';
import { text } from '../data';

interface ProgressBarProps {
	progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ( { progress } ) => {
	let progressWidth: number;

	if ( progress <= 0 ) {
		progressWidth = 0;
	} else if ( progress >= 1 ) {
		progressWidth = 100;
	} else {
		progressWidth = progress * 100;
	}

	return (
		<div className="c-guided-help__progress">
			<div className="c-guided-help__progress-title">{text.progress}</div>
			<div
				className="progress"
				role="progressbar"
				aria-label={text.progress}
				aria-valuenow={progressWidth}
				aria-valuemin={0}
				aria-valuemax={100}
			>
				<div
					className="progress-bar"
					style={{ width: `${ progressWidth }%` }}
				></div>
			</div>
		</div>
	);
};

export default ProgressBar;
